const diseases = [
    "Diabetes",
    "Hipertensión arterial",
    "Dislipidemias (colesterol o triglicéridos altos)",
    "Sobrepeso / Obesidad",
    "Enfisema pulmonar",
    "Insuficiencia renal",
    "Alergias",
    "Gastritis",
    "Colitis",
    "Dolor de espalda o problemas posturales",
    "Ansiedad",
    "Depresión",
    "Cáncer",
  ];
  
  export default diseases;
  